import { useState, type FormEvent } from "react";

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get("company_alt") as string || "").trim();
    if (honeypot) {
      setFormStatus("success");
      return;
    }

    formData.delete("company_alt");

    window.setTimeout(() => {
      setFormStatus("success");
      setFormError("");
      form.reset();
    }, 300);
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950"
            style={{ fontFamily: "var(--font-heading)" }}>
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            有任何意见或建议？欢迎随时联系我们
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
          <div className="lg:w-1/2">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">
                  您的姓名
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-500 transition-colors duration-200"
                  placeholder="请输入您的姓名"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">
                  电子邮箱
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-500 transition-colors duration-200"
                  placeholder="请输入您的邮箱"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">
                  留言内容
                </label>
                <textarea
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-500 transition-colors duration-200 resize-none"
                  placeholder="请输入您的留言内容（500字以内）"
                ></textarea>
              </div>
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              <button
                type="submit"
                className="px-8 py-3 text-sm font-semibold bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                发送留言
              </button>

              {formStatus === "success" && (
                <p className="text-sm text-accent-600">感谢您的留言，我们会尽快回复！</p>
              )}
              {formStatus === "error" && (
                <p className="text-sm text-red-500">{formError}</p>
              )}
            </form>
          </div>

          <div className="lg:w-1/2 flex flex-col justify-center">
            <div className="space-y-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                  <i className="ri-mail-line text-lg text-primary-500"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">电子邮箱</p>
                  <p className="text-sm text-foreground-500">hello@hongtongren.com</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                  <i className="ri-information-line text-lg text-accent-500"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">关于页面</p>
                  <p className="text-sm text-foreground-500">hongtongren.com/about</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 flex-shrink-0">
                  <i className="ri-home-4-line text-lg text-secondary-500"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">网站首页</p>
                  <p className="text-sm text-foreground-500">hongtongren.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
